import api from 'apis/config/api-service';

interface User {
  id?: string | number;
  [key: string]: any;
}

interface UserParams {
  [key: string]: any;
}

interface PasswordParams {
  [key: string]: any;
}

export default {
  getUsers: (params?: UserParams) => api.get(`users`, { ...params }),
  addOrUpdateUser: (user: User) => (user.id ? api.patch(`users/${user.id}`, user) : api.post('users', user)),
  getUserById: (userId: string | number) => api.get(`users/${userId}`),
  getUserByMe: () => api.get(`users/me`),
  changePassword: (params: PasswordParams) => api.post('users/change-password', params),
};
